import 'normalize.css'
import 'core/sass/base.sass'
import 'core/sass/typography.sass'
import 'core/sass/utilities.sass'

import React from 'react'
import ReactDOM from 'react-dom'

import App from 'core/components/App'
import ErrorBoundary from 'core/components/ErrorBoundary'

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('wrapper')
)
